import React from "react";
import ServicesSection from "../ServicesSection/ServicesSection";

const Services = () => {
  return (
    <>
      <ServicesSection></ServicesSection>
    </>
  );
};

export default Services;
